export default __webpack_public_path__ + "static/media/logo_small.451c230d.png";